import { ProductDownload } from '@/types/entity/product';
import { classnames } from '@/utils/classnames/classnames';

interface DownloadsRowProps {
  downloads: ProductDownload[];
  className?: string;
}

// EWM-198 — Dan's outlined-pill download buttons. Each opens in a new tab so
// PDFs render in the browser's PDF viewer or trigger native download per
// MIME type (browser-controlled).
const DownloadsRow = ({ downloads, className }: DownloadsRowProps) => (
  <div className={classnames('flex flex-wrap gap-3', className)}>
    {downloads.map((download, index) => (
      <a
        key={`${download.label}-${index}`}
        href={download.url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={download.label}
        className="border-primary text-primary hover:bg-primary text-14 inline-flex items-center gap-2 rounded-full border-2 bg-white px-5 py-2.5 font-semibold transition-colors hover:text-white"
      >
        {download.label}
      </a>
    ))}
  </div>
);

export default DownloadsRow;
